import { createFileRoute } from "@tanstack/react-router";
import { buildNoindexHead } from "@/lib/noindex-seo";
import Page from "@/pages/complete-profile";

export const Route = createFileRoute("/complete-profile")({
  head: () => buildNoindexHead("Complete Profile", "/complete-profile"),
  component: Page,
});
